/**
 * @generated SignedSource<<c59a77fa68870fb340e072c7d315239c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventSalesOrderInlineFragment$data = {
  readonly id: string;
  readonly event: {
    readonly id: string;
    readonly beginsAt: any;
  };
  readonly " $fragmentType": "eventSalesOrderInlineFragment";
};
export type eventSalesOrderInlineFragment$key = {
  readonly " $data"?: eventSalesOrderInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventSalesOrderInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "eventSalesOrderInlineFragment"
};

(node as any).hash = "69f093f02290c63e235c3a1c1e40ba98";

export default node;
